// extracted by mini-css-extract-plugin
export default {"root":"MakeCard-module--root--fa233","flexRow":"MakeCard-module--flexRow--ab3c5"};